function editNestedKeyValue<T>(objectSearch: T, keySearch: string, valueReplace: unknown): T {
    let returnValue = objectSearch;

    if (returnValue === undefined || returnValue === null) {
        /* Return original value */
    } else if (Array.isArray(objectSearch)) {
        returnValue = objectSearch.map(item =>
            editNestedKeyValue<T>(item as T, keySearch, valueReplace),
        ) as unknown as T;
    } else if (typeof returnValue === 'object') {
        const objectCast = returnValue as Record<string, unknown>;
        Object.keys(objectCast).forEach(keyObj => {
            /* Must cast to Record before using index signatures */
            const valueObj = objectCast[keyObj];
            const newValue =
                keyObj === keySearch
                    ? valueReplace
                    : editNestedKeyValue(valueObj, keySearch, valueReplace);
            objectCast[keyObj] = newValue;
        });
    } else {
        /* Return original value */
    }

    return returnValue;
}

export default Object.freeze({
    editNestedKeyValue,
});
